import NProgress from "nprogress";
import React, { useEffect } from "react";
import { FC } from "react";

import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const LoadingScreen: FC<React.PropsWithChildren<unknown>> = () => {
  useEffect(() => {
    NProgress.start();

    return (): void => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        minHeight: "100%",
        padding: 3,
      }}
    >
      <Box sx={{ width: 400 }}>
        <LinearProgress />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
